import React, { useState } from "react";
import ReactEcharts from "echarts-for-react";
import * as _ from "lodash";

const OperatorLineBar = ({ data, chartRef, xKey = "name", yKey, label }) => {
  const xValues = _.map(data, xKey);
  const yValues = _.map(data, yKey);
  const maxYValue = _.max(yValues);

  const chartData = {
    dataZoom: [
      {
        type: "slider",
        xAxisIndex: 0,
        filterMode: "filter",
        height: 10,
        bottom: 0,
        start: 0,
        end: 26,
        handleIcon:
          "path://M10.7,11.9H9.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4h1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z",
        showDetail: false,
        zoomLock: true,
      },
    ],
    label: {
      normal: {
        show: true,
        position: "top",
      },
    },
    color: ["#fd625e"],
    tooltip: {
      trigger: "axis",
      axisPointer: {
        type: "cross",
        crossStyle: {
          color: "#999",
        },
      },
    },
    grid: {
      left: "5%",
      bottom: "30%",
      right: "5%",
      top: "30%",
    },
    xAxis: {
      type: "category",
      data: xValues,
      name: "",
      nameLocation: "center",
      axisTick: {
        show: true,
      },
      z: 10,
      nameTextStyle: {
        align: "center",
        verticalAlign: "top",
        /**
         * the top padding will shift the name down so that it does not overlap with the axis-labels
         * t-l-b-r
         */
        padding: [30, 0, 0, 0],
        //backgroundColor: "yellow",
      },
      axisLabel: {
        inside: false,
        interval: 0,
        fontSize: 8,
        rotate: 45,
        height: 200,
        //backgroundColor: 'red',
        width: 100, //fixed number of pixels
        ellipsis: "truncate",
        interval: 0,
        formatter: function (operator) {
          return operator;
        },
      },
      // the default nameGap=15 would move the text to the right
      nameGap: 0,
      label: {
        normal: {
          show: true,
          position: "top",
        },
      },
    },
    yAxis: {
      type: "value",
      name: label,
      min: 0,
      max: maxYValue,
      nameGap: 40,
      //position: 'right'
    },
    series: [
      {
        name: label,
        data: yValues,
        type: "bar",
        label: {
          normal: {
            show: true,
            position: "top",
            rotate: 90,
            fontSize: 9,
            verticalAlign: "middle",
            padding: [0, 0, 0, 10],
            formatter: (params) => {
              return `  ${params.value ? params.value : ""}`;
            },
          },
        },
      },
    ],
    /* toolbox: {
      feature: {
        saveAsImage: {
          type: 'png',
          name: 'mi-grafica'
        }
      }
    }, */
  };

  return (
    <React.Fragment>
      <div>
        <ReactEcharts
          ref={chartRef}
          style={{ height: "400px" }}
          option={chartData}
        />
      </div>
      {/* <button onClick={downloadImage}>Descargar imagen</button>
      <img src={image} /> */}
    </React.Fragment>
  );
};

export default OperatorLineBar;
